import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Disclosure, Menu, Transition} from '@headlessui/react'
import {Bars3Icon, BellIcon, XMarkIcon} from '@heroicons/react/24/outline'

import PropertyNavigation from "../../components/common/navigation.component";
import MainNavigation from "../../components/common/navigation.component";
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {Link, useLoaderData, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {
    copyTextToClipboard,
    isIDInArray,
    isIndexInArray,
    MetaTags,
    smallEventCard
} from "../../components/common/utilities";
import {ChevronDownIcon, MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import {DateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment/moment";
import FindVenues from "../venues/findVenues";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import FindPerformer from "../performers/findPerformers";
import {Helmet} from "react-helmet-async";
// import Redactor
import '../../redactor-4-1-6/redactor.min.css';
import Redactor from '../../redactor-4-1-6/redactor.usm.min.js';

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function NLPPrompt({theData}) {
    const navigate = useNavigate();
    const logout = () => {
        window.location.href = '/logout';
    }

    let editor;
    let params = useParams();
    const venueID = params.venueID;
    const loaderdata = useLoaderData() as any;
    console.log(loaderdata);
    const today = new Date();
    const dateString = today.toISOString().split('T')[0];

    const [events, setEvents] = useState([]);
    const [edp, setEDP] = useState([]);
    const [eventOffset, setEventOffset] = useState(0);
    const [eventLimit, setEventLimit] = useState(10);
    const [NLPStatus, setNLPStatus] = useState([]);
    const [NLPUrl, setNLPUrl] = useState([]);
    const [NLPData, setNLPData] = useState<SchemaEvent>();
    const [loading, setLoading] = useState(false);
    const [notJson, setNotJson] = useState(false);
    const [failedResponse, setFailedResponse] = useState("");
    const [isEvent, setIsEvent] = useState(false);
    const [isVenue, setIsVenue] = useState(false);
    const [isAttraction, setIsAttraction] = useState(false);
    const [system, setSystem] = useState("");
    const [assistant, setAssistant] = useState("");
    const [prompt, setPrompt] = useState("");


    var date = new Date();
    //let aieditor = Redactor('#aieditor');
    const getEvents = nextOffset => {
        axios.get(`${process.env.REACT_APP_API_URL}/go/promogogo/timeline.do?`, {
            params: {
                limit: 10, offset: nextOffset, json: 1, filter: 'EVENT', date: date.toISOString(),
            }

        }).then(function (response) {
            // handle success
            console.log("events", response);
            setEvents(response.data.moments);
            setEventOffset(eventOffset + eventLimit);
        });
    }

    const getNLP = (url): any => {
        axios.get(url).then(function (response) {
            // handle success
            console.log("NLPdata", response.data);
            setNotJson(false);
            if (response.data.status)
            {
                setNLPStatus(response.data.status);
            }
            if (response.data.status === 'SUCCESS' && response.data.result)
            {
                setLoading(false);
                setCount(0);
                let nlpdata = response.data.result;
                nlpdata = nlpdata.replaceAll("```json\n", "");
                nlpdata = nlpdata.replaceAll("\n```", "");
                try {
                    nlpdata = JSON.parse(nlpdata);
                }
                catch(e) {
                    console.log(e);
                    setNotJson(true);
                    setFailedResponse(nlpdata);
                }

                //editor = Redactor('#aieditor');

                setNLPData(nlpdata);
                console.log(nlpdata);

            }
            else if (response.data.status === 'FAILURE')
            {
                setLoading(false);
                setCount(0);
                localStorage.removeItem('nlpurl');
            }
            else
            {
                setLoading(true);
                pollNLP(url);
            }

        });

    }

    const refreshNLP = () => {
        getNLP(NLPUrl);
    }

    const [count, setCount] = useState(0);

    const pollNLP = (url) => {
        setCount(count + 1);
        setTimeout(() => getNLP(url), 5000)
    }

    const splitEvent = (event) => {
        event.preventDefault()
        axios.post(`https://translator.promogogo.com/nlp/chat`, {
            prompt: event.target.elements.prompt.value, system: event.target.elements.system.value, assistant: event.target.elements.assistant.value,
        }, {
                       headers: {
                           'instance': loaderdata.instance, 'face-uri': loaderdata.url,
                       },
                   }).then(function (response) {
            // handle success
            console.log("Prompt response", response.data);
            if (response.data.url)
            {
                setNLPUrl(response.data.url);
                localStorage.setItem('nlpprompturl', response.data.url);
                getNLP(response.data.url);
            }

        }).catch(function (error) {
            // handle error
            console.log(error);

        });
    }

    const getMoreEvents = () => {
        getEvents(eventOffset);
    }

    useEffect(() => {
        console.log(theData);

        if(theData['@type'] == 'Event')
        {
            setIsEvent(true);
            setSystem('I am a website for a music festival.');
            let assistantString = 'I need a description for an event.  The description should be returned in a SchemaEvent format in a JSON document only. The description should use appropriate HTML tags.';
            setAssistant(assistantString);
            let promptstring = 'The event is called '+theData.name+'.';
            if(theData.description)
            {
                promptstring = promptstring+' The event  has this description: '+theData.description;
            }

            setPrompt(promptstring);
        }
        else if(theData['@type'] == 'Place')
        {
            setIsVenue(true);
            setSystem('I am a website for a music festival.');
            setAssistant('I need a description for a venue.  The description should be returned in a SchemaPlace format in a JSON document only. The description should use appropriate HTML tags.');
            setPrompt('The Venue is called '+theData.name);
            if(theData.description)
            {
                setPrompt('The venue is called '+theData.name+ " and has this description: "+theData.description);
            }
        }
        else
        {
            setIsAttraction(true);
            setSystem('I am a website for a music festival.');
            setAssistant('I need a description for an artist.  The description should be returned in a SchemaArtist format in a JSON document only. The description should use appropriate HTML tags.');
            setPrompt('The artist is called '+theData.name);
            if(theData.description)
            {
                setPrompt('The artist is called '+theData.name+ " and has this description: "+theData.description);
            }

        }

        if (localStorage.getItem('nlpprompturl'))
        {
            getNLP(localStorage.getItem('nlpprompturl'));
        }

    }, []);

    const [open, setOpen] = useState(false);

    type SchemaEvent = {
        [key: string]: any; // ?? variable key
        name: string;
    };
    type SchemaLocation = {
        [key: string]: any; // ?? variable key
        name: string;
    };

    const [eventData, setEventData] = useState<SchemaEvent>();
    const [venueData, setVenueData] = useState<SchemaLocation>();
    const [performers, setPerformers] = useState([]);
	const [performerIndex, setPerformerIndex] = useState([]);


    const createEvent = (e) => {
        e.preventDefault();
        console.log(e);
		if(performers && performers.length > 0)
		{
			setEventData({
							 ...eventData,
							 performers

						 })
		}


        console.log('posting ', eventData);
        axios.post(`${process.env.REACT_APP_API_URL}/p/api/event/create.do`, eventData, {}).then(function (response) {
            // handle success
            console.log(response);
            setEventData(response.data);
            //setOpen(false);
            //setRooms(response.data.collection);
            //window.location.href = '/onboarding/room/'+response.data.collection[0]['guid'];

        });
    }

    const viewEvent = (event) => {
        console.log(event);
		setPerformers([]);
		setPerformerIndex([]);
        event['@id'] = '';
        if (!event.localEndDate)
        {
            const end = new Date(event.localStartDate);
            end.setHours(end.getHours() + 2);
            event.localEndDate = end.toISOString();
        }
        setEventData(event);
        setVenueData(event.location);
        setOpen(true);
    }



const setDescription = (e) => {
        //let html = aieditor.editor.getContent();
       // console.log(html);
}


    return (<>
    {/*
        This example requires updating your template:

        ```
        <html class="h-full">
        <body class="h-full">
        ```
      */}



        <div className="mt-2">
            <div className="px-4 sm:px-6 lg:px-8">
                <h3 className={'text-2xl font-bold tracking-tight text-gray-900 mb-2'}>AI NLP Module</h3>
                <div className="">
                    <div className="">
                        <form className="" onSubmit={splitEvent}>
                            <label htmlFor="splitevent" className="block text-sm font-medium leading-6 text-gray-900">
                            </label>
                            <textarea
                                id="spliteventsystem"
                                className="block w-full p-2 border rounded-md my-2 resize-none border-gray-400 py-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                                name="system"
                                rows={2}
                                defaultValue={system}
                            />
                            <textarea
                                id="spliteventassistnt"
                                className="block w-full p-2 border rounded-md my-2 resize-none border-gray-400 py-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                                name="assistant"
                                rows={2}
                                defaultValue={assistant}
                            />
                            <textarea
                                id="splitevent"
                                className="block w-full p-2 border rounded-md my-2 resize-none border-gray-400 py-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                                name="prompt"
                                rows={5}
                                defaultValue={prompt}
                            />

                            <div className="md:grid gap-4 grid-cols-3 mt-2">
                                <div className="p-2">
                                    <button type={'submit'}
                                            className={'block rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'}>
                                        Send to AI
                                    </button>
                                </div>
                                <div className={'p-2 mt-2'}>
                                    <span className={'text-sm text-gray-500'}>{loading && <i className="fa-solid fa-spinner fa-spin"></i>}
                                     &nbsp;{NLPStatus}</span>
                                </div>
                                <div className={'p-2'}>
                                    {NLPUrl.length > 0 && <button onClick={refreshNLP}
                                                                  className={'block rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'}>Refresh</button>}
                                </div>
                            </div>


                        </form>

                    </div>
                    <div>
                        {NLPData && NLPData.description && <>
                            <h3 className={'text-2xl font-bold tracking-tight text-gray-900 mt-4'}>AI says:</h3>
                            <div id={'airesults'} className={'p-3'} dangerouslySetInnerHTML={{__html: NLPData.description}} onClick={(e) => copyTextToClipboard(NLPData.description)}></div>
                        </>}
                        {NLPData && NLPData.description &&
                         <button className={'block rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'}
                                    onClick={(e) => setDescription(e)}

                         >Set Description</button>}
                        {NLPData && NLPData.members && <>
                            {NLPData.members.map((member, index) => (<div key={index} className="mt-4">
                                {index === 0 && <h5 className="text-sm font-bold mb-2">Members</h5>}
                                <div className="flex items-center">
                                    <div className="flex-shrink-0">
                                        <img className="h-12 w-12 rounded-lg" src={member.image} alt=""/>
                                    </div>
                                    <div className="ml-4">
                                        <h4 className="text-lg font-bold">{member.name}</h4>
                                        <p className="mt-1">{member.jobTitle}</p>
                                    </div>
                                </div>
                            </div>))}
                        </>}
                        {NLPData && NLPData.member && <>
                            {NLPData.member.map((member, index) => (<div key={index} className="mt-4">
                                {index === 0 && <h5 className="text-sm font-bold mb-2">Members</h5>}
                                <div className="flex items-center">
                                    <div className="flex-shrink-0">
                                        <img className="h-12 w-12 rounded-lg" src={member.image} alt=""/>
                                    </div>
                                    <div className="ml-4">
                                        <h4 className="text-lg font-bold">{member.name}</h4>
                                        <p className="mt-1">{member.jobTitle}</p>
                                    </div>
                                </div>
                            </div>))}
                        </>}
                        {NLPData && NLPData.genre && NLPData.genre.isArray && <>
                            {NLPData.genre.map((agenre, index) => (<div key={index} className="mt-4">
                                {index === 0 && <h5 className="text-sm font-bold mb-2">Genre</h5>}
                                <div className="flex items-center">

                                    <div className="ml-4">
                                        <h4 className="text-lg font-bold">{agenre}</h4>
                                    </div>
                                </div>
                            </div>))}
                        </>}
                        {NLPData && NLPData.genre && !NLPData.genre.isArray && <>
                            <div className="mt-4">
                                <h5 className="text-sm font-bold mb-2">Genre</h5>
                                <div className="flex items-center">

                                    <div className="ml-4">
                                        <h4 className="text-lg font-bold">{NLPData.genre}</h4>
                                    </div>
                                </div>
                            </div>
                        </>}
                        {NLPData && NLPData.url && <>
                            <div className="mt-4">
                                <h5 className="text-sm font-bold mb-2">Website</h5>
                                <div className="flex items-center">

                                    <div className="ml-4">
                                        <h4 className="text-lg font-bold">{NLPData.url}</h4>
                                    </div>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        </div>


</>)
}
